import { render } from "./footerbar.vue?vue&type=template&id=4328e9a8&scoped=true"
import script from "./footerbar.vue?vue&type=script&lang=js"
export * from "./footerbar.vue?vue&type=script&lang=js"

import "./footerbar.vue?vue&type=style&index=0&id=4328e9a8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4328e9a8"]])

export default __exports__